import { z } from 'zod/v3';
import { zIsoDate, zValidPeriod } from '../../common/utils';
import { zIsoDateTime } from '../../common/utils/schema/zIsoDateTime';
import { ValidationErrorSchema } from '../../processingEvent/schema/OutputProcessingEventDetailsSchema';

export const OutputTestValidationDetailsSchema = z.object({
  versionId: z.number(),
  code: z.string(),
  name: z.string(),
  statusCode: z.string(),
  versionNumber: z.number(),
  validPeriod: zValidPeriod(),
  validationRuleCode: z.string(),
  valueDate: zIsoDate(),
  outputDataVersionId: z.number(),
  outputDataVersionNumber: z.number(),
  outputDataVersionMinorNumber: z.number().nullable(),
  outputDataVersionStatusId: z.number(),
  dagRunId: z.string(),
  queueTime: zIsoDateTime().nullable(),
});

export const OutputTestValidationSchema = z.object({
  startTime: zIsoDateTime().nullable(),
  endTime: zIsoDateTime().nullable(),
  validationErrors: ValidationErrorSchema.array(),
});
